import { ETemplateStudioBundlesViewModel } from './enums';

export const BUNDLE_VIEW_MODEL_TO_OFFERS_PER_ROW: Partial<
  Record<ETemplateStudioBundlesViewModel, number>
> = {
  [ETemplateStudioBundlesViewModel.LINEAR]: 1,
  [ETemplateStudioBundlesViewModel.TWO_IN_ONE]: 2,
  [ETemplateStudioBundlesViewModel.THREE_IN_ONE]: 3
};
